// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import InvoiceSubmitController from "./invoice_submit_controller"
application.register("invoice-submit", InvoiceSubmitController)

import InvoiceTableController from "./invoice_table_controller"
application.register("invoice-table", InvoiceTableController)

import InvoiceCopyController from "./invoice_copy_controller"
application.register("invoice-copy", InvoiceCopyController)

import InvoiceCoaTotalsController from "./invoice_coa_totals_controller"
application.register("invoice-coa-totals", InvoiceCoaTotalsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import InvoiceClassificationSyncController from "./invoice_classification_sync_controller"
application.register("invoice-classification-sync", InvoiceClassificationSyncController)

import InvoiceRowEditController from "./invoice_row_edit_controller"
application.register("invoice-row-edit", InvoiceRowEditController)

import InvoicePdfZoomController from "./invoice_pdf_zoom_controller"
application.register("invoice-pdf-zoom", InvoicePdfZoomController)

import InvoiceFormCsrfController from "./invoice_form_csrf_controller"
application.register("invoice-form-csrf", InvoiceFormCsrfController)
